import * as React from 'react'
import Alert from './AlertModal'
import { AlertButton } from './AlertStyles'

const ConfirmIcon = require('./icon-confirm.svg')

const ConfirmationModal = props => (
  <Alert>
    <img src={ConfirmIcon} className="alert-icon" alt="" />
    <h2>CONFIRM?</h2>
    <h4>{props.children}</h4>
    <div className="button-wrapper">
      <AlertButton color="green" onClick={props.onConfirm}>
        OK
      </AlertButton>
      <AlertButton color="gray" onClick={props.onCancel}>
        CANCEL
      </AlertButton>
    </div>
  </Alert>
)

export default ConfirmationModal



// WEBPACK FOOTER //
// ./src/Components/Shared/Alerts/Confirmation.tsx